import React, { useEffect, useState } from "react";
import { Activity, Mail, BarChart3, Loader2, CheckCircle2, XCircle } from "lucide-react";
import { toast } from "sonner";
import { superApi } from "../lib/admin";

const btn = "inline-flex items-center gap-2 rounded-full bg-white border border-[#E8DCCB] px-4 py-2.5 text-xs font-display font-bold active:scale-95 hover:bg-[#F5F1E8] transition-colors disabled:opacity-50";

export const OpsAlerts = () => {
    const [latest, setLatest] = useState(null);
    const [busy, setBusy] = useState(null);

    useEffect(() => {
        superApi.get("/super/health-check/latest").then((r) => setLatest(r.data.latest)).catch(() => {});
    }, []);

    const run = async (key, path, onOk) => {
        setBusy(key);
        try {
            const r = await superApi.post(path);
            onOk(r.data);
        } catch (e) {
            toast.error(e?.response?.data?.detail || "Request failed");
        } finally {
            setBusy(null);
        }
    };

    const actions = [
        { key: "health", icon: Activity, label: "Run health check now", path: "/super/health-check/run",
          ok: (d) => { setLatest(d); toast[d.ok ? "success" : "error"](d.ok ? "All checks passed — emailed you" : "Some checks failed — see below"); } },
        { key: "monthly", icon: BarChart3, label: "Email me last month's report", path: "/super/reports/monthly/send",
          ok: (d) => toast.success(d.sent ? `Report for ${d.report.label} sent` : "Report built, but email failed") },
        { key: "alert", icon: Mail, label: "Send test new-café alert", path: "/super/alerts/test-onboarding",
          ok: (d) => toast.success(d.ok ? `Test alert sent to ${d.to}` : "Email failed") },
    ];

    return (
        <section data-testid="ops-alerts" className="mt-14 rounded-3xl bg-white border border-[#E8DCCB] p-6">
            <h2 className="font-display font-black text-2xl">Alerts & reports</h2>
            <p className="text-sm text-[#8C7A72] mt-1">
                Automatic: new-café email on every signup · monthly report on the 1st · health check every other day via Cafetown.
            </p>
            <div className="flex flex-wrap gap-2 mt-5">
                {actions.map((a) => (
                    <button key={a.key} data-testid={`ops-${a.key}-btn`} disabled={!!busy} onClick={() => run(a.key, a.path, a.ok)} className={btn}>
                        {busy === a.key ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <a.icon className="h-3.5 w-3.5" strokeWidth={2.5} />}
                        {a.label}
                    </button>
                ))}
            </div>
            {latest && (
                <div data-testid="ops-health-latest" className="mt-6">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#8C7A72] font-semibold mb-3">
                        Last health check · {new Date(latest.ran_at).toLocaleString("en-AU", { timeZone: "Australia/Sydney" })} Sydney
                    </div>
                    <div className="grid gap-2 md:grid-cols-3">
                        {latest.checks.map((c) => (
                            <div key={c.name} data-testid={`ops-check-${c.name.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="flex items-start gap-2 rounded-2xl bg-[#F9F6F0] px-3 py-2.5">
                                {c.ok ? <CheckCircle2 className="h-4 w-4 text-[#1B995E] shrink-0 mt-0.5" /> : <XCircle className="h-4 w-4 text-[#c73810] shrink-0 mt-0.5" />}
                                <div className="min-w-0">
                                    <div className="font-display font-bold text-sm">{c.name}</div>
                                    <div className="text-xs text-[#8C7A72] truncate" title={c.detail}>{c.detail}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </section>
    );
};

export default OpsAlerts;
